import { render, staticRenderFns } from "./IcoCompetencyType.vue?vue&type=template&id=380e6792"
import script from "./IcoCompetencyType.vue?vue&type=script&lang=js"
export * from "./IcoCompetencyType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports